import Login from './Login.jsx';
import PageNotFound from './PageNotFound.jsx';

import {
  ListBusinesses,
  AddBusiness,
  EditBusiness,
  BusinessPage,
  BusinessPageWithSlug,
  RegisterBusiness,
  DaNangBusinessPage
} from './businesses';

import Register from './Register';
import Signin from './Signin';
import SigninWithTicket from './SigninWithTicket';
import ForgotPassword from './ForgotPassword';
import AllCategories from './AllCategories';
import CMSPage from './CMSPage';
import {FeedbackPage} from './feedback';
import {ProductDetailPage} from './product-detail';
import {CategoryDetailPage} from './category-detail';
import {ListProductPage} from './list-product';
import {ListCategoryPage} from './list-category';
import {ThankPage} from './thank';
import {RestorePasswordPage} from './restore-password';
import {ContactPage} from './contact';

import {
  MyBusinessPage,
  MyBusinessAddProductPage,
  MyBusinessAddFairProductPage,
  MyBusinessManageProductPage,
  MyBusinessEditProductPage,
  MyBusinessListFairProductPage,
  MyBusinessPaymentsPage,
  MyBusinessFairPage,
  MyBusinessAnnouncementPage,
  MyBusinessAnnouncementDetailPage,
  MyBusinessStatsPage,
  MyBusinessManageOrderPage,
  MyBusinessManageOrderDetailPage,
  MyBusinessPostDemandPage
} from './my-business';

import {
  NewsCategoryPage,
  NewsDetailPage
} from './news';

import {
  FAQPage
} from './faq';

import {
  FairDashBoardPage
} from './fair';

import {
  NeedOfferDetailPage,
  MybusinessNeedOfferDetailPage,
  MybusinessNeedOfferPage
} from './need-offer';

import {
  ListDemandPage,
  DetailDemandPage
} from './demand';

import {
  SearchProductPage
} from './search-product';

export {
  Login,
  PageNotFound,
  Register,
  Signin,
  SigninWithTicket,
  ForgotPassword,
  AllCategories,
  ProductDetailPage,
  CategoryDetailPage,
  ListProductPage,
  MyBusinessPage,
  MyBusinessAddProductPage,
  MyBusinessManageProductPage,
  MyBusinessEditProductPage,
  MyBusinessPaymentsPage,
  MyBusinessFairPage,
  BusinessPage,
  BusinessPageWithSlug,
  ListCategoryPage,
  ThankPage,
  RestorePasswordPage,
  ContactPage,
  NewsCategoryPage,
  NewsDetailPage,
  RegisterBusiness,
  FAQPage,
  CMSPage,
  FeedbackPage,
  FairDashBoardPage,
  NeedOfferDetailPage,
  MybusinessNeedOfferDetailPage,
  MybusinessNeedOfferPage,
  MyBusinessAddFairProductPage,
  MyBusinessListFairProductPage,
  MyBusinessAnnouncementPage,
  MyBusinessAnnouncementDetailPage,
  ListDemandPage,
  DetailDemandPage,
  MyBusinessStatsPage,
  MyBusinessManageOrderPage,
  MyBusinessManageOrderDetailPage,
  SearchProductPage,
  MyBusinessPostDemandPage,
  DaNangBusinessPage
};



// WEBPACK FOOTER //
// ./pages/index.js